import { createHttpEndpoint } from '../../utils'

import type { GetCategoriesLeafLight } from './categories.types'

/**
 * Retrieves list of category Information
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/catalog-access-api/definition#tag/Categories/paths/~1bm~1category~1leaf~1light/get}
 */
export const getCategoriesLeafLight =
  createHttpEndpoint<GetCategoriesLeafLight>({
    method: 'GET',
    operationId: 'getCategoriesRequest',
    path: '/bm/category/leaf/light',
    transformResponseToCamelCase: true,
  })
